var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      ref: "selector",
      attrs: {
        size: "960px",
        title: "",
        visible: _vm.stateInner.dialogVisible,
        "append-to-body": true,
        "modal-append-to-body": true,
        "destroy-on-close": true,
        "before-close": _vm.close,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.stateInner, "dialogVisible", $event)
        },
      },
    },
    [
      _c("yxt-user-selector", {
        ref: "userselector",
        attrs: {
          functionCode: _vm.functionCode,
          dataPermissionCode: _vm.dataPermissionCode,
          data: _vm.states.users,
          tabs: _vm.states.tabs,
        },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "yxt-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.getUsers } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }